import colors, { options } from '@classify/design-tokens/colors';
import merge from 'lodash/merge';
import { alpha } from '../styles';

const MUIRequiredPalette = {
  primary: {
    // MUI
    main: colors.brand.primary,
    light: colors.brand.primary,
    dark: colors.brand.primary,
  },
  secondary: {
    // MUI
    main: options.dimGrey,
    light: options.dimGrey,
    dark: options.dimGrey,
  },
  error: {
    // MUI
    main: colors.notification.error.main,
    light: colors.notification.error.main,
    dark: colors.notification.error.main,
  },
};

const deprecatedPalette = {
  brand: {
    main: colors.brand.primary, // deprecated
    highlightPrimary: options.brightBlue, // deprecated
    highlightSecondary: options.springGreen, // deprecated
  },
  line: colors.layout.line.divider, // deprecated replaced by palette.layout.line.divider
  divider: colors.layout.line.divider, // deprecated
  stroke: options.whisper, // deprecated
  background: {
    // deprecated
    default: options.greyFifty, // deprecated
    primary: options.white, // deprecated
    secondary: options.black, // deprecated
    alternative: options.whiteSmoke, // deprecated replaced by layout.background.alternative
    neutral: options.wildSand, // deprecated
    brand: alpha(options.royalPurple, 0.08), // deprecated
    tableHead: options.midnightBlue, // deprecated
    information: options.lochmara, // deprecated
    warning: options.orange, // deprecated
    error: options.guardsmanRed, // deprecated
    question: options.dimGrey, // deprecated
    funding: options.pink, // deprecated
    cpf: options.cpfBlue, // deprecated
    projectHeader: options.whiteSmoke, // deprecated
    dashboard: options.greyFifty, // deprecated
    objectList: options.greyFifty, // deprecated
    gradient: {
      business: `linear-gradient(165deg, ${options.royalPurple} -16%, ${options.midnightBlue} 75%)`, // deprecated
      funding: `linear-gradient(180deg, ${options.pink} 0%, ${alpha(options.white, 0)} 100%), ${
        options.pink
      }`, // deprecated
    },
    marketing: {
      // deprecated
      secondary: options.portica, // deprecated
    },
  },
  text: {
    primary: colors.text.onMain, // deprecated
    hint: colors.text.onMain, // deprecated
    caption: colors.text.onMain, // deprecated
    secondary: options.dimGrey, // deprecated
    inactive: options.dimGrey, // deprecated
    link: options.royalPurple, // deprecated
    linkOnContrasted: colors.text.onMain, // deprecated
  },
  calendar: {
    mentorshipSession: options.lochmara, // deprecated
    presentation: options.aquaDeep, // deprecated
    weekdays: options.dimGrey, // deprecated
    today: options.dimGrey, // deprecated
    background: options.white, // deprecated
    text: colors.text.onMain, // deprecated
    textAlternative: options.white, // deprecated
    interactiveHeader: options.whiteSmoke, // deprecated
    selectedDate: options.royalPurple, // deprecated
    interactiveDay: alpha(options.royalPurple, 0.16), // deprecated
  },
  learningCategories: {
    development: options.blueLagoon, // deprecated
    network: options.lochmara, // deprecated
    marketing: options.blueRibbon, // deprecated
    data: options.aquaDeep, // deprecated
    projectManagement: options.daisyBush, // deprecated
    hr: options.navyBlue, // deprecated
    careerCoaching: options.amethyst, // deprecated
    design: options.amaranth, // deprecated
    pedagogy: options.pomegranate, // deprecated
    entrepreneurship: options.darkBlue, // deprecated
    finance: options.teal, // deprecated
    softSkills: options.ironstone, // deprecated
    other: options.royalPurple, // deprecated
  },
  analytics: {
    primary: options.navyBlue, // deprecated
    secondary: alpha(options.amethyst, 0.64), // deprecated
  },
  roles: {
    admin: options.blueLagoon, // deprecated
    manager: options.navyBlue, // deprecated
    teamManager: options.amethyst, // deprecated
    mentor: options.lochmara, // deprecated
    recruiter: options.darkBlue, // deprecated
  },
  status: {
    // deprecated (Replaced by notification)
    notStarted: colors.notification.neutral.main, // deprecated
    inactive: colors.notification.neutral.main, // deprecated
    notCompleted: options.alto, // deprecated
    success: colors.notification.valid.main, // deprecated
    awaiting: colors.notification.info.main, // deprecated
    info: colors.notification.info.main, // deprecated
    inProgress: colors.notification.valid.main, // deprecated
    retry: options.orange, // deprecated
    warning: colors.notification.warning.main, // deprecated
    fail: colors.notification.error.main, // deprecated
    danger: colors.notification.danger.main, // deprecated
    neutral: options.gainsboro, // deprecated
  },
};

const palette = {
  ...merge(deprecatedPalette, colors),
  ...MUIRequiredPalette,
};

export default palette;
